import Cookies from 'js-cookie'
import { useRecoilValue } from 'recoil'
import { useAws } from 'src/networking/aws'
import { atomDossier } from 'src/storage'
import { AwsGateCallbacks, AwsGateRequest, PostQuote } from 'src/types'

export const usePostQuote = <T extends PostQuote['request'], D extends PostQuote['response']>() => {
  const hook = useAws<T, D>('postQuote')
  const dossier = useRecoilValue(atomDossier)

  return {
    ...hook,
    crossGate: (request: AwsGateRequest<T>, callbacks: AwsGateCallbacks<D>) => {
      request.headers = {
        ...request.headers,
        Authorization: Cookies.get('IdToken') || '',
        xDossierId: dossier?.dossierId,
      }
      return hook.crossGate(
        {
          method: 'post',
          path: `/preventivo`,
          ...request,
        },
        callbacks
      )
    },
  }
}
